import { EditPopup } from './edit-popup';

type Props = {
  value: string;
  open: boolean;
  onSubmit: (plan: string) => void;
  onClose: VoidFunction;
};

export const EditMonthlyResult = ({ value, open, onSubmit, onClose }: Props) => (
  <EditPopup
    title="Установить месячный план"
    value={value}
    onSubmit={onSubmit}
    onClose={onClose}
    open={open}
  />
);
